import React from 'react';
import Web3Modal from 'web3modal';
import Web3 from 'web3';

class ConnectWallet extends React.Component {
    state = { account: '' };

    componentDidUpdate(prevProps) {
      if (!prevProps.connect && this.props.connect) {
        this.connectWallet();
      }
    }

    connectWallet = async () => {
        this.props.onError('');

        const web3Modal = new Web3Modal({
            network: "mainnet", // Set this to the network your contract is deployed on
            cacheProvider: true,
            disableInjectedProvider: false,
        });

        let provider;
        try {
            provider = await web3Modal.connect();
        } catch (error) {
            console.error("Failed to connect:", error);
            this.props.onError('Failed to connect: ' + error.message);
            return;
        }

        if (provider) {
            const web3 = new Web3(provider);
            const networkId = await web3.eth.net.getId(); // Get the network ID

            if (networkId !== 1) { 
                this.props.onError('You are connected to the wrong network. Please switch to Ethereum Network.');
                return;
            }

            const accounts = await web3.eth.getAccounts();
            this.setState({ account: accounts[0] }, () => {
                this.props.onConnect(accounts[0]);
            });
        } else {
            this.props.onError('No Ethereum provider was found. Please consider trying MetaMask!');
        }
    }

    render() {
        return null;
    }
}

export default ConnectWallet;
